'use client';
import React from 'react';
import { PostNode } from '@/types/global';
import AnalysesCard from '@/components/(postTypes)/analysis/AnalysesCard';

interface AnalysesProps {
    analyses?: PostNode[];
}

const AnalysisBlog: React.FC<AnalysesProps> = ({ analyses }) => {
    return (
        <>
            {analyses && (
                <div className={'w-full overflow-hidden'}>
                    <div
                        className={
                            'mb-6 flex xl:text-xl border-b border-black/10 dark:border-white/10'
                        }
                    >
                        <h3 className={'border-b-2 pb-2 border-progress'}>آخرین تحلیل‌ها</h3>
                    </div>
                    <div
                        className={
                            'flex flex-nowrap overflow-x-scroll w-full xl:grid sm:grid-cols-2 xl:grid-cols-6 gap-3'
                        }
                    >
                        {analyses.map((post) => (
                            <AnalysesCard
                                className={'max-md:w-5/12 max-xl:w-[22%] shrink-0'}
                                key={post.databaseId}
                                post={post}
                            />
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default AnalysisBlog;
